// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39A_p","placeholdersHeader":"styles_placeholdersHeader__HdHaC","editorStyle":"styles_editorStyle__28rv7","placeholdersBox":"styles_placeholdersBox__1vpS2"};